import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import StyledTableCell from "../../StyledTable/StyledTableCell/StyledTableCell";
import StyledTableRow from "../../StyledTable/StyledTableRow/StyledTableRow";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { formatCurrency } from "../../../../../../utils/formatHelpers";
import { CarrierService } from "../../../../../../services/CarrierService";
import { AlertContext } from "../../../../../Dashboard/Dashboard";

export default function SubmittedComchecksTableRow({
  row,
  setComcheckToEdit,
  setStep,
  handleDeleteStagedComcheck,
  setStagedComchecksArray
}) {
  const { instance } = useMsal();
  const [expressCode, setExpressCode] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { warning } = useContext(AlertContext);

  const handleEdit = (row) => {
    setStagedComchecksArray([]);
    setComcheckToEdit(row);
    setStep(1);
  };

  useEffect(() => {
    setIsLoading(true);

    if (row.comcheckType === "Accessorial") {
      const accessorialPayload = {
        driverExtraPayId: row.accessorialId,
        driverName: row.driverName,
        movementId: row.movementId,
        orderId: row.loadId,
        issuingUserId: row.userId,
        amount: row.totalAmount
      };

      CarrierService.CreateAccessorialComcheck(instance, accessorialPayload).then(res => {
        if (res.responseCode === 0) {
          setError(false);
          setExpressCode(res.expressCheckNumber);
        } else {
          setError(true);
          setErrorMessage(res.responseMessage);
        }
        setIsLoading(false);
      }).catch(error => {
        setError(true);
        setIsLoading(false);
        console.error(error);

        if (error.rspJson?.errors) {
          let errors = "";
          Object.values(error.rspJson.errors).forEach(o => { errors += " " + o; });
          setErrorMessage(errors);
        } else {
          setErrorMessage("Error occurred when requesting the Comcheck");
        }
        warning(error);
      });
    }

    if (row.comcheckType === "Fuel Advance") {
      const fuelAdvancePayload = {
        driverFirstName: row.driverName,
        sealNumber: row.sealNumber,
        bolNumber: row.bolNumber,
        movementId: row.movementId,
        orderId: row.loadId,
        carrierId: row.carrierId,
        issuingUserId: row.userId,
        amount: row.totalAmount,
        requestedAmount: row.requestedAmount
      };

      CarrierService.CreateFuelAdvanceComcheck(instance, fuelAdvancePayload).then(res => {
        if (res.responseCode === 0) {
          setError(false);
          setExpressCode(res.expressCheckNumber);
        } else {
          setError(true);
          setErrorMessage(res.responseMessage);
        }
        setIsLoading(false);
      }).catch(error => {
        setError(true);
        setIsLoading(false);
        console.error(error);

        if (error.rspJson?.errors) {
          let errors = "";
          Object.values(error.rspJson.errors).forEach(o => { errors += " " + o; });
          setErrorMessage(errors);
        } else {
          setErrorMessage("Error occurred when requesting the Comcheck");
        }
        warning(error);
      });
    }

    if (row.comcheckType === "Paid in Full") {
      const paidInFullPayload = {
        driverFirstName: row.driverName,
        sealNumber: row.sealNumber,
        bolNumber: row.bolNumber,
        movementId: row.movementId,
        orderId: row.loadId,
        carrierId: row.carrierId,
        issuingUserId: row.userId,
        amount: row.totalAmount,
        requestedAmount: row.requestedAmount
      };

      CarrierService.CreatePaidInFullComcheck(instance, paidInFullPayload).then(res => {
        if (res.responseCode === 0) {
          setError(false);
          setExpressCode(res.expressCheckNumber);
        } else {
          setError(true);
          setErrorMessage(res.responseMessage);
        }
        setIsLoading(false);
      }).catch(error => {
        setError(true);
        setIsLoading(false);
        console.error(error);

        if (error.rspJson?.errors) {
          let errors = "";
          Object.values(error.rspJson.errors).forEach(o => { errors += " " + o; });
          setErrorMessage(errors);
        } else {
          setErrorMessage("Error occurred when requesting the Comcheck");
        }
        warning(error);
      });
    }
  }, []);

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Typography variant="body1" color="black_solid.80">
          {row.reason}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        {isLoading &&
          <CircularProgress sx={{ color: "primary.60" }} size={22} />
        }
        {!isLoading && expressCode &&
          <Typography variant="body1" color="black_solid.80">
            {expressCode}
          </Typography>
        }
        {!isLoading && error &&
          <Typography variant="body1" color="error.60">
            {errorMessage}
          </Typography>
        }
      </StyledTableCell>
      <StyledTableCell>
        <Typography variant="body1" color="black_solid.80">
          {formatCurrency(row.totalAmount, 2)}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        {!isLoading && error &&
          <Box sx={{ display: "flex" }}>
            <Box sx={{ marginRight: "10px" }}>
              <InlineIconButton 
                onClick={() => handleDeleteStagedComcheck(row)} 
                icon={DeleteIcon}
                color="grey"
              />
            </Box>
            <Box>
              <InlineIconButton 
                onClick={() => handleEdit(row)} 
                icon={EditIcon}
                color="grey"
              />
            </Box>
          </Box>
        }
      </StyledTableCell>
    </StyledTableRow>
  );
}

SubmittedComchecksTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  setComcheckToEdit: PropTypes.func,
  setStep: PropTypes.func,
  handleDeleteStagedComcheck: PropTypes.func,
  setStagedComchecksArray: PropTypes.func.isRequired
};